import useSWR from 'swr'

// 테마 데이터를 가져오는 fetcher 함수
const fetchBrandTheme = async () => {
	try {
		console.log('🎨 브랜드 테마 API 호출 시작...');
		const response = await fetch('/theme.json', {
			cache: 'no-cache', // 항상 최신 테마를 가져옴
			headers: {
				'Cache-Control': 'no-cache'
			}
		});
		
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		
		const brandTheme = await response.json();
		console.log('✅ 브랜드 테마 로딩 성공:', brandTheme.name);
		
		return brandTheme;
	} catch (error) {
		console.error('❌ 브랜드 테마 로딩 실패:', error);
		throw error;
	}
};

// 브랜드 테마를 useSWR로 관리하는 훅
export const useBrandTheme = () => {
	const { data, error, mutate, isValidating } = useSWR(
		'BRAND_THEME', // SWR 키
		fetchBrandTheme,
		{
			revalidateOnFocus: false, // 포커스 시 재검증 비활성화
			revalidateOnReconnect: false, // 재연결 시 재검증 비활성화
			revalidateIfStale: true, // stale 상태여도 재검증 (중요!)
			refreshInterval: 0, // 주기적 갱신 비활성화
			dedupingInterval: 5000, // 5초간 중복 요청 방지 (60초에서 줄임)
			errorRetryCount: 0, // 에러 시 재시도 안함 (빠르게 실패)
			shouldRetryOnError: false, // 에러 시 재시도 하지 않음
			fallbackData: undefined // null 대신 undefined 사용
		}
	);

	console.log('🔍 useBrandTheme 상태:', {
		hasData: !!data,
		hasError: !!error,
		isValidating,
		isLoading: !error && !data && isValidating,
		dataName: data?.name
	});

	return {
		brandTheme: data,
		isLoading: !error && !data && isValidating,
		isError: !!error,
		isValidating,
		refreshTheme: mutate, // 수동으로 테마 새로고침
	};
};

export default useBrandTheme;